import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { api } from "api";
import type { ProviderSettingsPatientResponse } from "api/responses";

type Options = Omit<UseQueryOptions<ProviderSettingsPatientResponse>, "queryKey" | "queryFn">;

/**
 * Client hook to obtain the current Provider settings for patients.
 * @param options Options for the client call; provides callbacks for when the API call succeeds or fails.
 * @param form True if calling component is an editable settings form.
 * @returns React Query properties.
 */
export function useGetProviderSettingsPatient(form?: boolean, options?: Options) {
    return useQuery({
        ...options,
        queryKey: ["providerSettingsPatient"],
        queryFn: async (context) => await api.provider.patientSettings(context.signal),
        staleTime: form ? Infinity : 4 * 60 * 1000, // 4 minutes
        refetchOnMount: form ? "always" : true,
        refetchOnWindowFocus: !form,
    });
}
